import {h, Fragment} from "preact"
import { IconGrid1, IconGrid2, IconGrid3, IconGrid4 } from "../../icons"
import { useGridLayout } from "../../../contexts/GridLayoutContext"
const layouts = [
    { size: 1, title: "Single column grid", icon: <IconGrid1 />, className: 'hide small--flex' },
    { size: 2, title: "2 column grid", icon: <IconGrid2 />, className: 'flex' },
    { size: 3, title: "3 column grid", icon: <IconGrid3 />, className: 'flex small--hide' },
    { size: 4, title: "4 column grid", icon: <IconGrid4 />, className: 'hide large--flex' },
]

export default function LayoutSelector () {

    const { gridSize, setGridSize } = useGridLayout();

    return (
        <div className="flex align-items-center layout-selector">
            {layouts.map(layout => 
                <button 
                    key={`layout-${layout.size}`} 
                    ariaLabel={layout.title} 
                    onClick={() => setGridSize(layout.size)}
                    className={`btn-layout ${layout.className} ${parseInt(layout.size) === parseInt(gridSize) ? 'active' : ''}`}>
                        {layout.icon}
                </button>
            )}
        </div>
    )
}